/**
 * @param {Object} props
 * @param {IconSize} [props.iconSize]
 * @returns {React.ReactElement} The rendered component
 */
const SearchIcon = ({ iconSize }) => {
  if (iconSize === 'md') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.4198 6.00398C17.7758 8.47598 17.9598 12.368 15.9638 15.06L19.4758 18.504C19.8198 18.84 19.8318 19.392 19.4998 19.74C19.1838 20.076 18.6518 20.096 18.3118 19.776C18.3038 19.772 18.2998 19.764 18.2918 19.76L14.8038 16.276C12.2398 18.368 8.53181 18.176 6.17181 15.704C3.61981 13.028 3.61981 8.68398 6.17181 6.00398C8.72381 3.32398 12.8678 3.32798 15.4198 6.00398ZM7.32781 7.21598C9.24381 5.20798 12.3478 5.20798 14.2638 7.21598C16.1798 9.22398 16.1798 12.48 14.2638 14.492C12.3478 16.5 9.24381 16.5 7.32781 14.492C5.41181 12.484 5.41181 9.22798 7.32781 7.21598Z"
          fill="#002967"
        />
      </svg>
    );
  }
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4175 2.00738C13.7722 4.478 13.9561 8.36782 11.9612 11.0583L15.4712 14.5004C15.815 14.8362 15.827 15.3879 15.4952 15.7357C15.1794 16.0715 14.6477 16.0915 14.3079 15.7717C14.2999 15.7677 14.2959 15.7597 14.2879 15.7557L10.8018 12.2736C8.23926 14.3645 4.53333 14.1726 2.17465 11.702C-0.375925 9.02745 -0.375925 4.68588 2.17465 2.00738C4.72522 -0.671124 8.86691 -0.667127 11.4175 2.00738ZM3.33 3.2187C5.24493 1.21182 8.3472 1.21182 10.2621 3.2187C12.1771 5.22558 12.1771 8.47976 10.2621 10.4906C8.3472 12.4975 5.24493 12.4975 3.33 10.4906C1.41507 8.48376 1.41507 5.22958 3.33 3.2187Z"
        fill="#002967"
      />
    </svg>
  );
};

export default SearchIcon;
